package com.patronat.top.ui.models

data class VenueModeratorOption(
    val id: String,
    val fullName: String,
    val roleLabel: String,
    val avatarUrl: String? = null
) {
    val initials: String
        get() = fullName
            .trim()
            .split(Regex("\\s+"))
            .filter { it.isNotBlank() }
            .take(2)
            .joinToString(separator = "") { part ->
                part.take(1)
            }
}
